var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    fill: "none",
    viewBox: "0 0 20 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 14.5866C0 14.2419 0.227639 13.9382 0.559569 13.8401L7.64344 11.7464C8.38953 11.5259 8.38953 10.4741 7.64344 10.2536L0.55957 8.15988C0.22764 8.06177 0 7.75812 0 7.41345V1.55959C0 0.360803 1.3037 -0.388434 2.34667 0.210957L18.7733 9.65137C19.8163 10.2508 19.8163 11.7492 18.7733 12.3486L2.34666 21.789C1.3037 22.3884 0 21.6392 0 20.4404V14.5866Z",
    clipRule: "evenodd"
  })));
};
export default SvgSend;